module.exports = __webpack_public_path__ + "img/7.4103fd78.jpg";